<template>
  <div class="product-detail">
    <div class="left-section">
      <h1>商品名称:{{ product.name }}</h1>
      <h1>商品价格:{{ product.price }}¥</h1>

      <img :src="product.qr" class="img" alt="Product Image" />
      <div class="agreement">
        <input
          type="checkbox"
          v-model="isAgreementChecked"
          id="agreement"
          required
        />
        <label for="agreement">
          我已阅读并同意
          <a @click="lookAuth">《动漫产品授权协议》</a>
        </label>
      </div>
    </div>
    <div class="right-section">
      <div class="questions">
        <div class="question" v-for="(question, index) in 4" :key="index">
          <div :class="['cirlce', , index <= 1 ? '' : 'other-color']">
            {{ index <= 1 ? "Q" : "A" }}
          </div>
          <div class="text">
            {{
              index === 0
                ? "付款后如何得到动漫原图？"
                : index === 1
                ? "付款后又不想要了怎么办"
                : index === 2
                ? "付款成功后，联系邮箱help@picopi.cn,获得动漫产品高清原图"
                : "付款成功后，如尚未向青牛出关索取高清图片，可发邮件至help@picopi.cn申请退款"
            }}
          </div>
        </div>
      </div>
      <label class="refund" for="agreement">
        查看
        <a @click="lookRefund">《退款说明》</a>
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProductDetail",
  data() {
    return {
      hadIdentify:false,// 是否已经实名认证
      isAgreementChecked: true,
      product: {},
      productName: "商品名称",
      productImage: "path/to/product-image.jpg",
    };
  },
  mounted() {
    this.product = JSON.parse(localStorage.getItem("product"));

  },
  methods: {
    lookAuth() {
      this.$router.push("auth");
    },
    lookRefund() {
      this.$router.push("refund");
    },
  },
};
</script>

<style scoped>
.product-detail {
  width: 100%;
  height: 100vh;
  padding: 100px 80px 0 120px;
  display: flex;
  position: relative;
  background: linear-gradient(180deg, yellow, white);
}
.refund {
  position: absolute;
  right: 520px;
  top: 290px;
}


.left-section {
  width: 35%;
}
.img {
  max-width: 250px;
  display: block;
  margin: 30px 0;
}

.right-section {
  width: 45%;
}

.questions {
  display: flex;
  flex-wrap: wrap;
  margin-top: 140px;
}

.question {
  width: 50%;
  box-sizing: border-box;
  padding: 10px;
  display: flex;
  align-items: center;
  margin-bottom: 40px;
}
.cirlce {
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #409eff;
  color: #000;
  border-radius: 50%;
}
.other-color {
  background-color: yellowgreen !important;
}
.text {
  margin-left: 10px;
  max-width: 200px;
  white-space: wrap;
}

a {
  color: blue;
  cursor: pointer;
    text-decoration: none;

}

a:hover {
  text-decoration: none;
}

button {
  margin-top: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/pay.vue